import { render, staticRenderFns } from "./AutomationTemplatesSellsy.vue?vue&type=template&id=016d7c38&scoped=true&"
import script from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
export * from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=0&id=016d7c38&prod&lang=scss&scoped=true&"
import style1 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=1&id=016d7c38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d7c38",
  null
  
)

export default component.exports